import { ColorPicker } from "antd";
import styled from "@emotion/styled";

export const StyledColorPicker = styled(ColorPicker)`
  height: auto;
  width: 75px !important;
`;
